import * as React from "react";
import Component from "../../AbstractComponent";
import { TableComponent } from "../../Partials/Table/TableComponent";
import { TabsComponent } from "./TabsComponent";
import { PaymentInterface } from "../../../Entity/Entities/Payment/PaymentInterface";
import { connect } from "react-redux";
import { DeleteEntityPrompt } from "../../Partials/Dialog/DeleteEntityPrompt";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { BankAccountInterface } from "../../../Entity/Entities/BankAccount/BankAccountInterface";
import PaymentsWillMount from "../../../Middleware/Middlewares/PaymentsWillMount";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import  PaymentClassContainer from "../../../Entity/Entities/Payment/PaymentClass/PaymentClassContainer";
import PaymentTypeContainer from "../../../Entity/Entities/Payment/PaymentType/PaymentTypeContainer";
import { DatePickerComponent } from "../../Partials/DatePicker/DatePickerComponent";
import Constants from "../../../Action/Constants";
import Select from "../../Partials/Material/Select";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Card from '@material-ui/core/Card';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TextField from "../../Partials/Material/TextField";
import CircularProgress from '@material-ui/core/CircularProgress';
import * as ReactTooltip from "react-tooltip";
import { UndoSettleWithSavingsDialog } from "../../Partials/Dialog/UndoSettleWithSavingsDialog";
import Memo from "../../Partials/Memo/Memo";
import PaymentCreateDialog from "../../Partials/Dialog/PaymentCreateDialog";
import LinearProgress from '@material-ui/core/LinearProgress';
import PontoPanel from '../../Partials/PontoPanel';
import PaymentCounterpartyDescriptionInfoForList from "../../Partials/Payment/PaymentCounterpartyDescriptionInfoForList";

class Payments extends Component {
  protected selectedPayment: PaymentInterface;
  protected selectedPaymentIndex: number;
  protected paginatorPath: string;
  protected searchTimer;
  public noteField: null;
  protected timerId: any;
  protected fileInput;
  protected textFieldRef;

  protected middlewares: MiddlewareInterface[] = [
    PaymentsWillMount
  ];

  public state = {
    anchorEl: null,
    payments: [],
    unusedPayments: [],
    unverifiedPayments: [],
    isFetching: true,
    filterValue: "",
    agencyBankAccountId: "all",
    filter: "unused",
    paymentsCount: 0,
    unusedPaymentsCount: 0,
    unverifiedPaymentsCount: 0,
    paymentToDelete: null,
    isPaymentRemovePopupOpen: false,
    isPaymentUnSettlePopupOpen: false,
    isPaymentUnlinkPopupOpen: false,
    isSaving: false,
    dateFilter: null,
    cannotDeleteSavingsPaymentDialog: false,
    searchInProgress: false,
    paymentToAddNote: null,
    note: "",
    memoPopupOpen: false,
    isUndoSavingsPopupOpen: false,
    isPaymentCreatePopupOpen: false,
    isBankTransactionsDilaogOpen: false,
    isDialogOpen: false,
    isBankTransFileRemoveOpen: false,
    transactionFile: null,
    openPontoMenu: false,
    showPontoDialog: false,
    pontoConnectionDialog: false,
    pontoConnectionDialogFromParams: false,
    pontoConnectionDialogMessageFromParams: "",
    showPontoDisconnectErrorDialog: false,
    pontoDisconnectErrorId: "",
  }

  constructor(public props) {
    super(props);

    this.fileInput = React.createRef();
    this.textFieldRef = React.createRef();
  }

  public componentWillUnmount() {
    clearTimeout(this.searchTimer);

    this.props.dispatch({
      type: Constants.FINANCE_PAYMENTS_FILTER_SEARCH_UPDATE_STATE,
      payload: {
        filter: this.state.filterValue
      }
    });
  }

  public componentWillReceiveProps(nextProps) {
    // Fetch all payments again if there is a change on payments
    // So user on different screen can see the changes.
    // Socket logic without sockets
    if (!this.props?.payments?.requestsOutdated && nextProps?.payments?.requestsOutdated) {
      this.fetchFirstAllPayments();
      this.fetchFirstUnusedPayments();
      this.fetchFirstUnverifiedPayments();
    }
  }

  public fetchFirstAllPayments = (callback?) => {
    const paginationAmount = !!this.props.app.paginator && !!this.props.app.paginator[this.paginatorPath] ?
      this.props.app.paginator[this.paginatorPath]: this.props.app.defaultPaginationAmount;

    const payload: any = {
      firstItem: 0,
      lastItem: paginationAmount,
      agencyBankAccount: this.state.agencyBankAccountId,
      filterValue: this.state.filterValue,
      removed: 0,
      isAfterStartDate: 1, // do not fetch charges before start date,
      removeType: [PaymentTypeContainer.pickIdFromLabel("Savings_account"), PaymentTypeContainer.pickIdFromLabel("Settlement")]
    };

    if (!!this.state.dateFilter) {
      payload.date = this.state.dateFilter;
    }

    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENTS_SAVE_LIST,
      payload: {
        ...payload
      },
      onSuccess: (data) => {
        this.setState({
          searchInProgress: false,
          payments: data.payments,
          paymentsCount: data.count,
          isFetching: false
        }, () => {
          if (typeof callback === "function") {
            callback();
          }
        })
      },
      onError: () => {
        this.setState({
          searchInProgress: false,
          isFetching: false
        });
      }
    });
  }

  public fetchFirstUnusedPayments = (callback?) => {
    const paginationAmount = !!this.props.app.paginator && !!this.props.app.paginator[this.paginatorPath] ?
      this.props.app.paginator[this.paginatorPath]: this.props.app.defaultPaginationAmount;

    const payload: any = {
      firstItem: 0,
      lastItem: paginationAmount,
      isFullyUsed: 0, // unused payments
      agencyBankAccount: this.state.agencyBankAccountId,
      filterValue: this.state.filterValue,
      removed: 0,
      isAfterStartDate: 1, // do not fetch charges before start date
      removeType: [PaymentTypeContainer.pickIdFromLabel("Savings_account"), PaymentTypeContainer.pickIdFromLabel("Settlement")]
    };

    if (!!this.state.dateFilter) {
      payload.date = this.state.dateFilter;
    }

    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENTS_SAVE_LIST,
      payload: {
        ...payload
      },
      onSuccess: (data) => this.setState({
        searchInProgress: false,
        unusedPayments: data.payments,
        unusedPaymentsCount: data.count,
        isFetching: false
      }, () => {
        if (typeof callback === "function") {
          callback();
        }
      }),
      onError: () => {
        this.setState({
          searchInProgress: false,
          isFetching: false
        });
      }
    });
  }

  public fetchFirstUnverifiedPayments = (callback?) => {
    const paginationAmount = !!this.props.app.paginator && !!this.props.app.paginator[this.paginatorPath] ?
      this.props.app.paginator[this.paginatorPath]: this.props.app.defaultPaginationAmount;

    const payload: any = {
      firstItem: 0,
      lastItem: paginationAmount,
      agencyBankAccount: this.state.agencyBankAccountId,
      filterValue: this.state.filterValue,
      removed: 0,
      isAfterStartDate: 1, // do not fetch charges before start date
      isBankTransaction: 1,
      isProcessed: 0, // not verified payments
      removeType: [PaymentTypeContainer.pickIdFromLabel("Savings_account"), PaymentTypeContainer.pickIdFromLabel("Settlement")]
    };

    if (!!this.state.dateFilter) {
      payload.date = this.state.dateFilter;
    }

    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENTS_SAVE_LIST,
      payload: {
        ...payload
      },
      onSuccess: (data) => this.setState({
        searchInProgress: false,
        unverifiedPayments: data.payments,
        unverifiedPaymentsCount: data.count,
        isFetching: false
      }, () => {
        if (typeof callback === "function") {
          callback();
        }
      }),
      onError: () => {
        this.setState({
          searchInProgress: false,
          isFetching: false
        });
      }
    });
  }

  public fetchFilterAllPayments = () => {
    const payload: any = {
      filterValue: this.state.filterValue,
      agencyBankAccount: this.state.agencyBankAccountId,
      removed: 0,
      isAfterStartDate: 1, // do not fetch charges before start date
      removeType: [PaymentTypeContainer.pickIdFromLabel("Savings_account"), PaymentTypeContainer.pickIdFromLabel("Settlement")]
    };

    if (!!this.state.dateFilter) {
      payload.date = this.state.dateFilter;
    }

    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENTS_SAVE_LIST,
      payload: {
        ...payload
      },
      onSuccess: data => {
        this.setState({
          payments: data.payments,
          paymentsCount: data.count
        })
      }
    })
  }

  public fetchFilterUnusedPayments = () => {
    const payload: any = {
      isFullyUsed: 0, // unused payments
      filterValue: this.state.filterValue,
      agencyBankAccount: this.state.agencyBankAccountId,
      removed: 0,
      isAfterStartDate: 1, // do not fetch charges before start date
      removeType: [PaymentTypeContainer.pickIdFromLabel("Savings_account"), PaymentTypeContainer.pickIdFromLabel("Settlement")]
    };

    if (!!this.state.dateFilter) {
      payload.date = this.state.dateFilter;
    }

    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENTS_SAVE_LIST,
      payload: {
        ...payload
      },
      onSuccess: data => {
        this.setState({
          unusedPayments: data.payments,
          unusedPaymentsCount: data.count
        })
      }
    })
  }

  public fetchFilterUnverifiedPayments = () => {
    const payload: any = {
      filterValue: this.state.filterValue,
      agencyBankAccount: this.state.agencyBankAccountId,
      removed: 0,
      isAfterStartDate: 1, // do not fetch charges before start date
      isBankTransaction: 1,
      isProcessed: 0, // not verified payments 
      removeType: [PaymentTypeContainer.pickIdFromLabel("Savings_account"), PaymentTypeContainer.pickIdFromLabel("Settlement")]
    };

    if (!!this.state.dateFilter) {
      payload.date = this.state.dateFilter;
    }

    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENTS_SAVE_LIST,
      payload: {
        ...payload
      },
      onSuccess: data => {
        this.setState({
          unverifiedPayments: data.payments,
          unverifiedPaymentsCount: data.count
        })
      }
    })
  }

  public clearFilterAllPayments = () => {
    this.props.dispatch({
      type: Constants.FINANCE_PAYMENTS_FILTER_SEARCH_UPDATE_STATE,
      payload: {
        filter: ""
      }
    });

    this.setState({
      filterValue: ""
    }, this.fetchFirstAllPayments);

    this.textFieldRef.current.focus();
  }

  public clearFilterUnusedPayments = () => {
    this.props.dispatch({
      type: Constants.FINANCE_PAYMENTS_FILTER_SEARCH_UPDATE_STATE,
      payload: {
        filter: ""
      }
    });

    this.setState({
      filterValue: ""
    }, this.fetchFirstUnusedPayments);

    this.textFieldRef.current.focus();
  }

  public clearFilterUnverifiedPayments = () => {
    this.props.dispatch({
      type: Constants.FINANCE_PAYMENTS_FILTER_SEARCH_UPDATE_STATE,
      payload: {
        filter: ""
      }
    });

    this.setState({
      filterValue: ""
    }, this.fetchFirstUnverifiedPayments);

    this.textFieldRef.current.focus();
  }

  public setFilterValue = (event): any => {
    clearTimeout(this.searchTimer);

    this.setState({
      filterValue: event.target.value
    } ,() => {
      if (this.state.filterValue === "") {
        if (this.state.filter === "all") {
          this.clearFilterAllPayments();
        } else if (this.state.filter === "unused") {
          this.clearFilterUnusedPayments();
        } else if (this.state.filter === "unverified") {
          this.clearFilterUnverifiedPayments();
        }
      }

      this.searchTimer = setTimeout(() => {
        this.setState({
          searchInProgress: true
        }, () => {
          this.paginatorPath = `Finance_Payments_${this.state.filter}_${this.state.agencyBankAccountId}_${this.state.dateFilter}_${this.state.filterValue}`;

          this.props.dispatch({
            type: Constants.FINANCE_PAYMENTS_FILTER_SEARCH_UPDATE_STATE,
            payload: {
              filter: this.state.filterValue
            }
          });

          if (this.state.filter === "all") {
            this.fetchFirstAllPayments();
          } else if (this.state.filter === "unused") {
            this.fetchFirstUnusedPayments();
          } else if (this.state.filter === "unverified") {
            this.fetchFirstUnverifiedPayments();
          }
        });
      }, this.props.app?.listSearchTimeout);
    });
  }

  public fetchPayments = () => {
    if (this.state.filter === "all") {
      const payload: any = {
        firstItem: !!this.state.payments ?  this.state.payments.length : 0,
        lastItem: !!this.state.payments && this.state.payments ? this.state.payments.length + this.props.app.defaultPaginationAmount : 0,
        agencyBankAccount: this.state.agencyBankAccountId,
        filterValue: this.state.filterValue,
        removed: 0,
        isAfterStartDate: 1, // do not fetch charges before start date
        removeType: [PaymentTypeContainer.pickIdFromLabel("Savings_account"), PaymentTypeContainer.pickIdFromLabel("Settlement")]
      };

      if (!!this.state.dateFilter) {
        payload.date = this.state.dateFilter;
      }

      this.props.dispatch({
        type: Constants.GLOBAL_PAYMENTS_SAVE_LIST,
        payload: {
          ...payload
        },
        onSuccess: (data) => {
          const paymentsArr: PaymentInterface[] = !!this.state.payments ?
                                                  [...this.state.payments, ...data.payments] : [...data.payments];

          this.setState({
            payments: paymentsArr,
            count: data.count
          });
        }
      });
    } else if (this.state.filter === "unused") {
      const payload: any = {
        firstItem: !!this.state.unusedPayments ?  this.state.unusedPayments.length : 0,
        lastItem: !!this.state.unusedPayments && this.state.unusedPayments ?
                                                  this.state.unusedPayments.length + this.props.app.defaultPaginationAmount : 0,
        isFullyUsed: 0, // unused payments
        agencyBankAccount: this.state.agencyBankAccountId,
        filterValue: this.state.filterValue,
        removed: 0,
        isAfterStartDate: 1, // do not fetch charges before start date
        removeType: [PaymentTypeContainer.pickIdFromLabel("Savings_account"), PaymentTypeContainer.pickIdFromLabel("Settlement")]
      };

      if (!!this.state.dateFilter) {
        payload.date = this.state.dateFilter;
      }

      this.props.dispatch({
        type: Constants.GLOBAL_PAYMENTS_SAVE_LIST,
        payload: {
          ...payload
        },
        onSuccess: (data) => {
          const unusedPaymentsArr: PaymentInterface[] = !!this.state.unusedPayments ?
                                          [...this.state.unusedPayments, ...data.payments] : [...data.payments];

          this.setState({
            unusedPayments: unusedPaymentsArr,
            unusedPaymentsCount: data.count
          });
        }
      });
    } else if (this.state.filter === "unverified") {
      const payload: any = {
        firstItem: !!this.state.unverifiedPayments ?  this.state.unverifiedPayments.length : 0,
        lastItem: !!this.state.unverifiedPayments && this.state.unverifiedPayments ?
                                                  this.state.unverifiedPayments.length + this.props.app.defaultPaginationAmount : 0,
        agencyBankAccount: this.state.agencyBankAccountId,
        filterValue: this.state.filterValue,
        removed: 0,
        isAfterStartDate: 1, // do not fetch charges before start date
        isBankTransaction: 1,
        isProcessed: 0, // not verified payments 
        removeType: [PaymentTypeContainer.pickIdFromLabel("Savings_account"), PaymentTypeContainer.pickIdFromLabel("Settlement")]
      };

      if (!!this.state.dateFilter) {
        payload.date = this.state.dateFilter;
      }

      this.props.dispatch({
        type: Constants.GLOBAL_PAYMENTS_SAVE_LIST,
        payload: {
          ...payload
        },
        onSuccess: (data) => {
          const unverifiedPaymentsArr: PaymentInterface[] = !!this.state.unverifiedPayments ?
                                          [...this.state.unverifiedPayments, ...data.payments] : [...data.payments];

          this.setState({
            unverifiedPayments: unverifiedPaymentsArr,
            unverifiedPaymentsCount: data.count
          });
        }
      });
    }
  }

  public changeFilter = (event: any): void => {
    const filter: string = event.target.value;

    this.setState({
      filter: filter
    }, () => {
      this.paginatorPath = `Finance_Payments_${this.state.filter}_${this.state.agencyBankAccountId}_${this.state.dateFilter}_${this.state.filterValue}`;

      this.props.dispatch({
        type: Constants.FINANCE_PAYMENTS_FILTER_UPDATE_STATE,
        payload: {
          filter: filter
        }
      });

      if (filter === "all") {
        if (this.state.filterValue) {
          this.fetchFilterAllPayments();
        } else {
          this.fetchFirstAllPayments();
        }
      } else if (filter === "unused") {
        if (this.state.filterValue) {
          this.fetchFilterUnusedPayments();
        } else {
          this.fetchFirstUnusedPayments();
        }
      } else if (filter === "unverified") {
        if (this.state.filterValue) {
          this.fetchFilterUnverifiedPayments();
        } else {
          this.fetchFirstUnverifiedPayments();
        }
      }
    });
  }

  public selectDate = (momentDate: any, identifier: string): any => {
    const date = !!momentDate && typeof momentDate.toDate === "function" ? momentDate.toDate() : momentDate;

    this.setState({
      [identifier]: date,
      hasModifiedData: true
    }, () => {
      this.props.dispatch({
        type: Constants.FINANCE_PAYMENTS_FILTER_DATE_UPDATE_STATE,
        payload: {
          filter: this.state.dateFilter
        }
      });

      if (this.state.filter === "all") {
        this.fetchFirstAllPayments();
      } else if (this.state.filter === "unused") {
        this.fetchFirstUnusedPayments();
      } else if (this.state.filter === "unverified") {
        this.fetchFirstUnverifiedPayments();
      }
    });
  }

  public getAmountsOfFilteredPayments = (filter: string): number => {
    switch (filter) {
      case "all":
        return this.state.paymentsCount;
      case "unused":
        return this.state.unusedPaymentsCount;
      case "unverified":
        return this.state.unverifiedPaymentsCount;
      default:
        return;
    }
  }

  public getFilteredPayments = (filter: string): PaymentInterface[] => {
    let payments = [];

    switch (filter) {
      case "all":
        payments = [...this.state.payments]
                .filter((payment: PaymentInterface) => payment.removed === false);
        break;
      case "unused":
        payments = [...this.state.unusedPayments]
                .filter((payment: PaymentInterface) => payment.removed === false);
        break;
      case "unverified":
        payments = [...this.state.unverifiedPayments]
                .filter((payment: PaymentInterface) => payment.removed === false);
        break;
      default:
        break;
    }

    return payments;
  }

  public changeBankAccountFilter = (event): void => {
    const bankAccountId: number = event.target.value;

    this.setState({
      agencyBankAccountId: String(bankAccountId)
    }, () => {
      this.paginatorPath = `Finance_Payments_${this.state.filter}_${this.state.agencyBankAccountId}_${this.state.dateFilter}_${this.state.filterValue}`;

      if (this.state.filter === "all") {
        this.fetchFirstAllPayments();
      } else if (this.state.filter === "unused") {
        this.fetchFirstUnusedPayments();
      } else if (this.state.filter === "unverified") {
        this.fetchFirstUnverifiedPayments();
      }

      this.props.dispatch({
        type: Constants.FINANCE_PAYMENTS_FILTER_BANK_ACCOUNT_UPDATE_STATE,
        payload: {
          index: String(bankAccountId)
        }
      });
    });
  }

  public delete = () => {
    const paymentToDelete: PaymentInterface = this.state.paymentToDelete;
    if(paymentToDelete?.paymentType?.id === PaymentTypeContainer.pickIdFromLabel("Savings_account")){
      return this.setState({
        isPaymentRemovePopupOpen: false,
        cannotDeleteSavingsPaymentDialog: true
      });
    }
    this.setState({
      isSaving: true
    });

    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENT_DELETE_START,
      payload: {
        payment: paymentToDelete
      },
      onSuccess: () => {
        const payments: PaymentInterface[] = [...this.state.payments];
        const unusedPayments: PaymentInterface[] = [...this.state.unusedPayments];
        const unverifiedPayments: PaymentInterface[] = [...this.state.unverifiedPayments];

        // need this to hide deleted payment from the list immediately
        if (this.state.filter === "all") {
          payments.splice(this.selectedPaymentIndex, 1);
          this.setState({
            paymentsCount: this.state.paymentsCount - 1,
            unusedPaymentsCount: !this.selectedPayment.isFullyUsed() ? this.state.unusedPaymentsCount - 1 : this.state.unusedPaymentsCount
          });
        } else if (this.state.filter === "unused") {
          unusedPayments.splice(this.selectedPaymentIndex, 1);
          this.setState({
            paymentsCount: !this.selectedPayment.isFullyUsed() ? this.state.paymentsCount - 1 : this.state.paymentsCount,
            unusedPaymentsCount: this.state.unusedPaymentsCount - 1
          });
        } else if (this.state.filter === "unverified") {
          unverifiedPayments.splice(this.selectedPaymentIndex, 1);
          this.setState({
            paymentsCount: !this.selectedPayment.isFullyUsed() ? this.state.paymentsCount - 1 : this.state.paymentsCount,
            unverifiedPaymentsCount: this.state.unverifiedPaymentsCount - 1
          });
        }

        this.setState({
          payments: [...payments],
          unusedPayments: [...unusedPayments],
          unverifiedPayments: [...unverifiedPayments],
          isSaving: false,
          isPaymentRemovePopupOpen: false,
          paymentDelete: null});
      },
      onError: () => {
        this.setState({
          isSaving: false,
          isChargeUlinkPopupOpen: false,
          isPaymentRemovePopupOpen: false,
          paymentDelete: null
        });
      }
    });
  }

  public unlink = (): any => {
    const payment: PaymentInterface = this.state.paymentToDelete;

    this.setState({
      isSaving: true
    });

    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENT_UNLINK_START,
      payload: {
        payment: payment
      },
      onSuccess: () => {
        this.fetchFirstAllPayments();
        this.fetchFirstUnusedPayments();
        this.fetchFirstUnverifiedPayments();

        this.setState({isPaymentUnlinkPopupOpen: false, isSaving: false});
      },
      onError: () => {
        this.setState({
          isPaymentUnlinkPopupOpen: false,
          isSaving: false
        });
      }
    });
  }

  public closePrompt = (): void => {
    this.setState({
      isPaymentRemovePopupOpen: false,
      isPaymentUnlinkPopupOpen: false,
      isPaymentUnSettlePopupOpen: false
    })
  }

  protected openMenu = (event: any, payment: PaymentInterface, index: number): void => {
    this.selectedPayment = payment;
    this.selectedPaymentIndex = index;

    this.setState({
      anchorEl: event.currentTarget
    });
  }

  protected closeMenu = (): void => {
    this.selectedPayment = null;
    this.selectedPaymentIndex = null;

    this.setState({
      anchorEl: null,
      openPontoMenu: false
    })
  }

  public unSettle = (): any => {
    const payment: PaymentInterface = this.state.paymentToDelete;

    this.setState({
      isSaving: true
    });

    this.props.dispatch({
      type: Constants.GLOBAL_PAYMENT_UNSETTLE_START,
      payload: {
        payment: payment
      },
      onSuccess: () => {
        this.fetchFirstAllPayments();
        this.fetchFirstUnusedPayments();
        this.fetchFirstUnverifiedPayments();

        this.setState({isPaymentUnSettlePopupOpen: false, isSaving: false});
      },
      onError: () => {
        this.setState({
          isPaymentUnSettlePopupOpen: false,
          isSaving: false
        });
      }
    });
  }

  public saveScrollPosition = () => {
    var top  = window.pageYOffset || document.documentElement.scrollTop;

    this.props.dispatch({
      type: Constants.DASHBOARD_PAYMENTS_LIST_POSITION_SAVE,
      payload: {
        position: top
      }
    });
  }

  public getTipText = (tip: string) => {
    const tipLength = 30;

    if (tip.length > tipLength) {
      return `${tip.slice(0, tipLength)}...`;
    }

    return tip;
  }

  public renderPaymentMemoIcon = (payment: PaymentInterface) => {
    return (
      <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
        <span>
          <span data-tip={this.getTipText(payment?.note)}>
          <div className={`icon ${payment?.hasMemos ? "icon-ic-bookmark blue-onhover" : "icon-ic-memo"}`}
              onClick={e => {
                e.stopPropagation();
                this.openMemoPopup(payment);
              }}
            >
            </div>
          </span>
          <ReactTooltip place="bottom" />
        </span>
      </div>
    );
  }

  public renderPaymentTypeIcon = (payment: PaymentInterface) => {
    if(!payment){
      return <div></div>
    }
    let paymentTypeIcon;
    const isSettle = payment?.isSettle;
    const hasSettlementType = payment?.paymentType?.id === PaymentTypeContainer.pickIdFromLabel("Settlement");
    const hasSavingsType = payment?.paymentType?.id === PaymentTypeContainer.pickIdFromLabel("Savings_account");

    if((isSettle || hasSettlementType) && !hasSavingsType) {
      paymentTypeIcon = "icon-ic-settle-1";
    } else if(payment?.isRefunded) {
      paymentTypeIcon = "icon-ic-replay";
    } else if(hasSavingsType) {
      paymentTypeIcon = "icon-ic-savings";
    } else {
      paymentTypeIcon = "";
    }

    return (
      <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
        <span>
          <div className={`icon ${paymentTypeIcon}`}></div>
        </span>
      </div>
    );
  }

  public openMemoPopup = (payment: PaymentInterface) => {
    this.setState({
      paymentToAddNote: payment, 
      note: payment?.note, 
      memoPopupOpen: true, 
      anchorEl: null 
    });
  }
  public saveDraft = (message) => {
    this.setState({
    note: message,
  })}
  
  public saveReminder = (payment: PaymentInterface) => {
    this.saving(() => {
      return this.props.dispatch({
        type: Constants.GLOBAL_PAYMENT_UPDATE_START,
        payload: {
          paymentId: payment?.id,
          payment: {note: this.state.note},
          updateMemo: true
        },
        onSuccess: () => {
          // need this to update charge from the list immediately
          if (this.state.filter === "all") {
            this.fetchFirstAllPayments();
          } else if (this.state.filter === "unused") {
            this.fetchFirstUnusedPayments();
          } else if (this.state.filter === "unverified") {
            this.fetchFirstUnverifiedPayments();
          }

          this.setState({
            isSaving: false, 
            memoPopupOpen: false
          })
        },
        onError: () => {
          this.setState({isSaving: false});

          this.props.dispatch({
            type: Constants.SNACKBAR_ADD_MESSAGE,
            payload: {
              message: this.trans("memo-can-not-be-updated"),
              type: "warning"
            }
          });
        }
      });
    });
  }

  public renderPaymentAmountHint = (payment: PaymentInterface) => {
    return (
      <span
        style={{
          fontSize: "11px",
          color: "#80808091"
        }}
      >
        {payment?.getPaymentAmountHint()}
      </span>
    );
  }

  public removeReminder = (payment: PaymentInterface) => {
    this.saving(() => {
      return this.props.dispatch({
        type: Constants.GLOBAL_PAYMENT_UPDATE_START,
        payload: {
          paymentId: payment?.id,
          payment: {note: ""},
          removeMemo: true
        },
        onSuccess: () => {
          // need this to update charge from the list immediately
          if (this.state.filter === "all") {
            this.fetchFirstAllPayments();
          } else if (this.state.filter === "unused") {
            this.fetchFirstUnusedPayments();
          } else if (this.state.filter === "unverified") {
            this.fetchFirstUnverifiedPayments();
          }

          this.setState({isSaving: false, memoPopupOpen: false})
        },
        onError: () => {
          this.setState({isSaving: false});
        }
      });
    });
  }

  public getPayments = () => {
    return this.getFilteredPayments(this.state.filter)
      .map((payment: PaymentInterface, index: number) => {
        if (!payment) {
          return;
        }

        let color = "#43A047";

        if (payment.amountUsed < payment.amount) {
          if (payment.amountUsed === 0) {
            color = "#F44336";
          } else {
            color = "#F5A623";
          }
        }

        return (
          <TableRow
            hover
            key={`payment-${index}`}
            className={`clickable-entity`}
            onClick={() => {
              this.saveScrollPosition();

              this.props.dispatch({
                type: Constants.PAGE_BANK_TRANSACTIONS_LIST_OF_NEXT_PAYMENTS_UPDATE,
                payload: {
                  payments: this.getFilteredPayments(this.state.filter),
                  index: this.getFilteredPayments(this.state.filter).findIndex(pmnt => pmnt?.id === payment?.id)
                }
              });

              this.redirect(`/app/payment/update/${payment.id}`);
            }}
          >
            <TableCell style={{width: "24px", paddingLeft: "24px", paddingRight: "5px"}}>
              <div style={{display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "4px"}}>
                <div
                  style={{color: color}}
                  className="icon icon-ic-payment"
                ></div>
              </div>
            </TableCell>
            <TableCell style={{width: "15%"}}>{this.formatter.formatDate(payment.dateOfThePayment)}</TableCell>
            <TableCell style={{width: "40%", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", maxWidth: "300px"}}>
              <PaymentCounterpartyDescriptionInfoForList payment={payment} />
            </TableCell>
            <TableCell style={{width: "10%"}}>
              {payment.paymentListTypeLabel() && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column"
                  }}
                >     
                  <div className={`list-label creation-type-label ${payment?.creationType?.id === 2 && "red"}`}>
                    {payment.paymentListTypeLabel()}
                  </div>     
                </div>
              )}
            </TableCell>
            <TableCell style={{width: "5%"}}>
              {this.renderPaymentMemoIcon(payment)}
            </TableCell>
            <TableCell style={{width: "5%"}}>
              {this.renderPaymentTypeIcon(payment)}
            </TableCell>
            <TableCell style={{ textAlign: "right", width: "20%" }}>
              <div style={{display: "inline-flex", flexDirection: "column"}}>
                <span>{payment.paymentClass.id == PaymentClassContainer.pickIdFromLabel("Payable")  && <span className="minus-style">{'-'}</span>}{this.formatter.formatNumber(payment.amount, payment.currency)}</span>
                {this.renderPaymentAmountHint(payment)}
              </div>
            </TableCell>
            <TableCell
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <div>
                <IconButton
                  onClick={e => this.openMenu(e, payment, index)}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorEl}
                  open={Boolean(this.state.anchorEl) && this.selectedPayment && this.selectedPayment.id === payment.id}
                  onClose={this.closeMenu}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    onClick={() => this.redirect(`/app/payment/update/${this.selectedPayment.id}`)}
                  >
                    <ListItemIcon><div className="icon icon-ic-edit icon-color"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                  </MenuItem>

                  <MenuItem
                    key={`add-memo-btn`}
                    onClick={() => {
                      if (this.checkProcessIsBusy({
                        action: "remove",
                        entityName: "payment",
                        entity: this.selectedPayment
                      })) {
                          this.openIsBusyPopup();
                          this.setState({anchorEl: null})
                        } else {
                          this.openMemoPopup(this.selectedPayment)
                        }
                      }
                    }
                  >
                    <ListItemIcon><div className="icon icon-ic-memo aligned"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-open-memo")}</ListItemText>
                  </MenuItem>
                  
                  <MenuItem
                    onClick={() => {
                      if (this.checkProcessIsBusy({
                                        action: "remove",
                                        entityName: "payment",
                                        entity: this.selectedPayment
                                      })) {
                        this.openIsBusyPopup();
                        this.setState({anchorEl: null})
                      } else {
                        this.setState({isPaymentRemovePopupOpen: true, paymentToDelete: this.selectedPayment, anchorEl: null});
                      }
                    }}
                  >
                    <ListItemIcon><div className="icon icon-ic-remove icon-color remove-icon"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                  </MenuItem>

                  {
                    this.selectedPayment?.isReferencedToSavings &&
                      <MenuItem
                        button
                        key={`add-remove-btn`}
                        onClick={() => {
                          if (this.checkProcessIsBusy({
                            action: "remove",
                            entityName: "payment",
                            entity: this.selectedPayment
                          })) {
                              this.openIsBusyPopup();
                              this.setState({anchorEl: null})
                            } else {
                              this.setState({
                                isUndoSavingsPopupOpen: true,
                                anchorEl: null
                              })
                            }
                          }
                        }
                      >
                      <ListItemIcon><div className="icon icon-ic-remove icon-color remove-icon"></div></ListItemIcon>
                      <ListItemText>{this.trans("menuitem-undo-settle-with-savings")}</ListItemText>
                    </MenuItem>
                  }
                </Menu>
              </div>
            </TableCell>
          </TableRow>
        );
      });
  }

  public openPaymentCreatePopup = () => {
    this.setState({
      isPaymentCreatePopupOpen: true
    });
  }

  public closeDialog = () => {
    this.setState({
      isDialogOpen: false
    });
  }

  public upload = (e: any): any => {
    const file = e.target.files[0];

    this.setState({
      isBankTransactionsDilaogOpen: false
    });

    this.props.dispatch({
      type: Constants.PAGE_BANK_TRANSACTIONS_SET_TITLE,
      payload: {
        title: this.trans("uploading")
      }
    });

    this.props.dispatch({
      type: Constants.PAGE_BANK_TRANSACTIONS_OPEN_DIALOG
    });

    this.setState({
      isDialogOpen: true
    });

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      this.props.dispatch({
        type: Constants.GLOBAL_TRANSACTION_FILE_UPLOAD_START,
        payload: {
          transactionFile: true,
          result: reader.result,
          file: file
        },
        onSuccess: transactionFile => {
          this.setState({
            transactionFile: transactionFile
          }, this.forceUpdate);
        },
        onError: () => {
          this.props.dispatch({
            type: Constants.PAGE_BANK_TRANSACTIONS_CLOSE_DIALOG
          });

          this.setState({
            isDialogOpen: false
          });
        }
      });
    };

    e.target.value = null;
  }

  public renderDialogContent = (): any => {
    const fileDetails = this.state.transactionFile && this.props.component.files[this.state.transactionFile.id] || this.props.component.defaultFile;

    // Uploading
    if (!!fileDetails && fileDetails.state === 1) {
      return (
        <div style={{ textAlign: "center" }}>
          <p>{this.trans("mt940-is-uploading")}</p>
          <CircularProgress size={40} thickness={2} />
        </div>
      );
    }

    // Processing
    if (!!fileDetails && fileDetails.state === 2) {
      if (!!fileDetails && fileDetails.current !== fileDetails.total) {
        clearTimeout(this.timerId);
        this.timerId = setTimeout(() => {
          this.setState({
            isDialogOpen: false
          });

          this.props.dispatch({
            type: Constants.SNACKBAR_ADD_MESSAGE,
            payload: {
              message: this.trans("mt-940-uploading-is-crashed"),
              type: "error"
            }
          });
        }, 30000);
      }

      return (
        <div style={{ textAlign: "center" }}>
          <p>{this.trans("mt-940-is-processing")}</p>
          <p>{this.trans("processing-x-of-y", { x: !!fileDetails && fileDetails.current, y: !!fileDetails && fileDetails.total })}</p>
          <div style={{padding: "0 24px"}}>
            <LinearProgress
              variant="determinate"
              value={100 / (!!fileDetails && fileDetails.total) * (!!fileDetails && fileDetails.current)}
            />
          </div>
        </div>
      );
    }

    // Success
    if (!!fileDetails && fileDetails.state === 3) {
      clearTimeout(this.timerId);

      return (
        <div>
          <p>{this.trans("mt-940-processing-finished-1")}</p>
            <ul>
              <li>
                <p>{this.trans("mt-940-processing-finished-total-count-payments", {count: !!fileDetails && fileDetails.current})}</p>
              </li>
              <li>
                <p>{this.trans("mt-940-processing-finished-created-count-payments", {count: !!fileDetails && fileDetails.countOfCreatedPayments})}</p>
              </li>
              {
                !!fileDetails && !!fileDetails.countOfExistingPayments && (
                  <li>
                    <p>{this.trans("mt-940-processing-finished-existing-count-payments", {count: !!fileDetails && fileDetails.countOfExistingPayments})}</p>
                  </li>
                )
              }
              {
                !!fileDetails && !!fileDetails.countOfNotRecognizedPayments && (
                  <li>
                    <p>{this.trans("mt-940-processing-finished-not-recognized-count-payments", {count: !!fileDetails && fileDetails.countOfNotRecognizedPayments})}</p>
                  </li>
                )
              }
            </ul>
          <p>{
            this.props.component.error || (!!fileDetails && fileDetails.state === 3 && fileDetails.countOfCreatedPayments === 0) ? this.trans("mt-940-processing-finished-2-close") :
            // this.trans("mt-940-processing-finished-2")
            ""
            }</p>
        </div>
      );
    }

    // Fail
    if (this.props.component.error) {
      return (
        <div>
          {this.image.getAvatar("info", { size: 75 })}
          <p>{this.props.component.translatedMessage}</p>
        </div>
      );
    }
  }

  public determineTitle = (): any => {
    const fileDetails = this.state.transactionFile && this.props.component.files[this.state.transactionFile.id] || this.props.component.defaultFile;

    if (!!fileDetails && fileDetails.disableButton === true) {
      return this.trans("title-please-wait");
    }

    if (this.props.component.error || (!!fileDetails && fileDetails.state === 3 && fileDetails.countOfCreatedPayments === 0)) {
      return this.trans("button-close");
    }

    return this.trans("button-continue");
  }

  public close = (): any => {
    this.setState({
      isDialogOpen: false
    });
  }

  public continue = (): any => {
    this.close()

    this.fetchFirstAllPayments(() => {
      window.scrollTo({
        top: this.props.app?.financePaymentsListPosition
      });
    });
    this.fetchFirstUnusedPayments(() => {
      window.scrollTo({
        top: this.props.app?.financePaymentsListPosition
      });
    });
    this.fetchFirstUnverifiedPayments(() => {
      window.scrollTo({
        top: this.props.app?.financePaymentsListPosition
      });
    });
  }

  public closeBankTransactionsDialog = () => {
    this.setState({
      isBankTransactionsDilaogOpen: false,
    })
  }

  public openBankTransactionsDilaog = () => {
    this.setState({
      isBankTransactionsDilaogOpen: true,
    })
  }

  public render() {
    const fileDetails = this.state.transactionFile && this.props.component.files[this.state.transactionFile.id] || this.props.component.defaultFile;

    const bankAccounts = this.getAgencyBankAccounts();
    let bankAccountForPonto = {} as any;
    if (bankAccounts && bankAccounts.length) {
      bankAccountForPonto = bankAccounts.filter(account => account?.pontoIntegration?.isConnected)?.[0] || {}
    }

    return (
      <div className="state-app">
        <div className={`box box-full component-finance full-width has-general-page-header with-tabs ${this.props.app?.settings?.user?.launchPanelState ? "with-launchpanel" : ""}`}>
          <div className="component-header no-paddings">
            <h1>{this.trans("title-finance")}</h1>
            <TabsComponent
              activeTab={1}
              {...this.props}
            />
          </div>

          <div className="component-wrapper no-margin-top">
            <Card className="card no-padding">
              <div className="label-container"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "baseline"
                }}
              >
                <h3 className="card-title">
                  {this.trans("payments")}
                </h3>
                <div className="button-container" style={{display: "flex", alignItems: "start"}}>
                  {!bankAccountForPonto?.pontoIntegration?.isConnected &&
                    <PontoPanel
                      {...this.props}
                      setState={(value) => this.setState({
                        ...value
                      })}
                      bankAccountId={bankAccountForPonto?.id}
                      pontoIntegration={bankAccountForPonto?.pontoIntegration}
                      showPontoDialog={this.state.showPontoDialog}
                    />
                  }
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      if (this.checkProcessIsBusy({
                                        action: "create",
                                        entityName: "payment"
                                      })) {
                        this.openIsBusyPopup();
                        this.setState({anchorEl: null})
                      } else {
                        this.openPaymentCreatePopup();
                      }
                    }}
                    style={{marginRight: "20px"}}
                  >
                    {this.trans("button-add-payment")}
                  </Button>
                  {!bankAccountForPonto?.pontoIntegration?.isConnected &&
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={this.openBankTransactionsDilaog}
                    >
                      {this.trans("upload-mt940-file")}
                    </Button>
                  }
                  {bankAccountForPonto?.pontoIntegration?.isConnected &&
                    <PontoPanel
                      {...this.props}
                      closeMenu={this.closeMenu}
                      bankAccountId={bankAccountForPonto?.id}
                      pontoIntegration={bankAccountForPonto?.pontoIntegration}
                      setState={(value) => this.setState({
                        ...value
                      })}
                      anchorEl={this.state.anchorEl}
                      openPontoMenu={this.state.openPontoMenu}
                      openBankTransactionsDilaog={this.openBankTransactionsDilaog}
                    />
                  }
                </div>
              </div>

              <div>
                <div
                  className="list-filters-wrapper"
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center"
                    }}
                  >
                    <RadioGroup
                      name="paymentsFilters"
                      value={this.state.filter}
                      onChange={this.changeFilter}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginRight: "15px"
                      }}
                    >
                      <FormControlLabel
                        value="all"
                        control={<Radio color="primary" />}
                        label={
                          (<span>{this.trans("all")}</span>)}
                      />
                      <FormControlLabel
                        value="unused"
                        control={<Radio color="primary" />}
                        label={
                          (<span>{this.trans("unused")}</span>)}
                      />
                      <FormControlLabel
                        value="unverified"
                        control={<Radio color="primary" />}
                        label={
                          (<span>{this.trans("to-verify")}</span>)}
                      />
                    </RadioGroup>

                    <DatePickerComponent
                      {...this.props}
                      id="filterDate"
                      name="filterDate"
                      className="scroll-to-filterDate filter-date-list"
                      label={this.trans("finance-payments-filter/date-label/paymentsbefore")}
                      initialDate={this.state.dateFilter}
                      onChange={date => this.selectDate(date, "dateFilter")}
                      clearButton={true}
                      error={this.getErrorFor("filterDate")}
                      width="200px"
                      style={{margin: 0}}
                    />

                    <div style={{width: "250px", paddingRight: "30px"}}>
                      <Select
                        className="full-size form-input"
                        style={{marginLeft: "25px", width: "250px"}}
                        htmlFor="bankAccount"
                        label={this.trans("label-bank-account")}
                        value={this.state.agencyBankAccountId}
                        onChange={this.changeBankAccountFilter}
                        name="bankAccount"
                        id="bankAccount"
                        error={this.getErrorFor("bankAccount")}
                      >
                        <MenuItem key={"all"} value={"all"} className="filter-payment-item table-bankaccount-dropdown"><div>{this.trans("all")}</div></MenuItem>
                        {
                          this.getAgencyBankAccounts()
                            .map((bankAccount: BankAccountInterface, key: number) => {
                              return (
                                <MenuItem
                                  key={`bankAccount-${key}`}
                                  value={bankAccount.id}
                                  className="filter-payment-item table-bankaccount-dropdown"
                                >
                                <div className="bank-account-menuitem-wrapper" style={{height: "14px"}}>
                                <div>{`${bankAccount.accountId ? `${bankAccount.accountId} - ` : ""} ${bankAccount.label !== "" && bankAccount.label ? `${bankAccount.label}` : ""}`}</div>

                                </div>
                                </MenuItem>
                              );
                            })
                        }
                      </Select>
                    </div>
                  </div>

                  <div className="table-filterer">
                    <TextField
                      autoComplete="off"
                      type="text"
                      style={{color: "rgb(0, 188, 212)"}}
                      label={this.trans("label-search")}
                      value={this.state.filterValue}
                      onChange={this.setFilterValue}
                      variant="standard"
                      error={false}
                      inputRef={this.textFieldRef}
                    />
                    { this.state.filterValue !== "" &&
                      <div className="icon icon-ic-close clear-button clear-button-search" onClick={this.state.filter === "all" ? this.clearFilterAllPayments : this.state.filter === "unused" ? this.clearFilterUnusedPayments : this.clearFilterUnverifiedPayments}></div>
                    }
                    { 
                      this.state.searchInProgress &&
                      <div className="search-loader">
                        <CircularProgress size={20} />
                      </div>
                    }
                  </div>
                </div>
                <TableComponent
                  {...this.props}
                  paginator={{
                    name: this.paginatorPath,
                    path: this.props.app.paginator
                  }}
                  className="listing-table with-first-border"
                  rows={this.getPayments()}
                  rowsLength={this.getAmountsOfFilteredPayments(this.state.filter)}
                  subtitle={this.trans("title-no-payments-to-list")}
                  fetch={this.fetchPayments}
                  isFetching={this.state.isFetching}
                  filtering={this.state.filterValue?.length > 0}
                />
              </div>
            </Card>
          </div>
        </div>

        <DeleteEntityPrompt
          {...this.props}
          entityName={this.state.paymentToDelete?.hasTransaction? "dialog-info/removetransaction" : "title-payment-delete-from-payment-page-content-dialog"}
          isOpen={this.state.isPaymentRemovePopupOpen}
          onCancel={this.closePrompt}
          onDelete={this.delete}
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={"title-payment-unsettle-from-charge-page-content-dialog"}
          isOpen={this.state.isPaymentUnSettlePopupOpen}
          onCancel={this.closePrompt}
          onDelete={this.unSettle}
          type="button-unsettle"
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={"title-payment-unlink-from-payment-page-content-dialog"}
          isOpen={this.state.isPaymentUnlinkPopupOpen}
          onCancel={this.closePrompt}
          onDelete={this.unlink}
          type="button-unlink"
        />

        <UndoSettleWithSavingsDialog 
          {...this.props}
          entity={this.selectedPayment}
          isOpen={this.state.isUndoSavingsPopupOpen}

          initializePage={() => {
            if (this.state.filter === "all") {
              this.fetchFirstAllPayments();
            } else if (this.state.filter === "unused"){
              this.fetchFirstUnusedPayments();
            } else if (this.state.filter === "unverified"){
              this.fetchFirstUnverifiedPayments();
            }
          }}
          closeDialog={() => this.setState({ isUndoSavingsPopupOpen: false, anchorEl: null })}
        /> 

        <PromptDialog
          {...this.props}
          title={this.trans("memo")}
          content={
            <div>
              <Memo 
                {...this.props}
                entity={this.state.paymentToAddNote}
                saveDraft={this.saveDraft}
                relations={{ paymentId: this.state.paymentToAddNote?.id }}
                fetchEntities={() => {
                  this.props.dispatch({
                    type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
                  });

                  if (this.state.filter === "all") {
                    this.fetchFirstAllPayments();
                  } else if (this.state.filter === "unused") {
                    this.fetchFirstUnusedPayments();
                  } else if (this.state.filter === "unverified") {
                    this.fetchFirstUnverifiedPayments();
                  }
                }}
              />
            </div>
          }
          prioritizeClosing={true}
          openLeavePrompt={this.state.memoPopupOpen}
          onlyPositiveButton={true}
          positiveButtonLabel={this.trans("button-close")}
          onSave={() => this.saveReminder(this.state.paymentToAddNote)}
          hideCross={true}
          subtitle={this.state.paymentToAddNote && this.state.paymentToAddNote.displayName ?
            this.state.paymentToAddNote.displayName : ""}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("dialog/attention-title") + "!"}
          content={
            <div>
              <span>{this.trans("title-remove-savings-payment-warning")}</span>
            </div>}
          openLeavePrompt={this.state.cannotDeleteSavingsPaymentDialog}
          positiveButtonLabel={this.trans("button-close")}
          onSave={() => this.setState({cannotDeleteSavingsPaymentDialog: false})}
          onlyPositiveButton={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("dialog/attention-title") + "!"}
          content={bankAccountForPonto?.pontoIntegration?.connectionMessage === "ponto_auth_expired" &&
          <>
            <p>{this.trans("ponto_auth_expired")}</p>
          </>
          }
          openLeavePrompt={this.props?.app?.pontoMessageShown}
          positiveButtonLabel={this.trans("button-close")}
          onSave={() => {
            this.props.dispatch({
              type: Constants.PONTO_CONNECTION_MESSAGE_SHOWN,
              payload: false
            });
          }}
          onDiscard={() => {
            this.props.dispatch({
              type: Constants.PONTO_CONNECTION_MESSAGE_SHOWN,
              payload: false
            });
          }}
          onlyPositiveButton={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("dialog/attention-title") + "!"}
          content={this.state?.pontoConnectionDialogMessageFromParams === "ponto_connection_success" ?
          <>
            <p>{this.trans("ponto_was_successfully_connected_1")}</p>
            <p>{this.trans("ponto_was_successfully_connected_2")}</p>
          </> :
          <>
            <p>{this.trans("ponto_failed_connection_1")}</p>
            <p>{this.trans("ponto_failed_connection_2", {message: this.state?.pontoConnectionDialogMessageFromParams})}</p>
          </>
          }
          openLeavePrompt={this.state.pontoConnectionDialogFromParams}
          positiveButtonLabel={this.trans("button-close")}
          onSave={() => {
            this.setState({pontoConnectionDialogFromParams: false});
            this.props.dispatch({
              type: Constants.PONTO_CONNECTION_MESSAGE_SHOWN,
              payload: false
            });
          }}
          onDiscard={() => {
            this.setState({pontoConnectionDialogFromParams: false});
            this.props.dispatch({
              type: Constants.PONTO_CONNECTION_MESSAGE_SHOWN,
              payload: false
            });
          }}
          onlyPositiveButton={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("dialog/attention-title") + "!"}
          content={
          <>
            <p>{this.trans("ponto_disconnect_failed_1")}</p>
            <p>{this.trans("ponto_disconnect_failed_2", {message: this.state?.pontoDisconnectErrorId})}</p>
          </>
          }
          openLeavePrompt={this.state?.showPontoDisconnectErrorDialog}
          positiveButtonLabel={this.trans("button-close")}
          onSave={() => {
            this.setState({
              showPontoDisconnectErrorDialog: false
            });
          }}
          onDiscard={() => {
            this.setState({
              showPontoDisconnectErrorDialog: false
            });
          }}
          onlyPositiveButton={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("dialog/attention-title") + "!"}
          content={this.state?.pontoConnectionDialogMessageFromParams === "ponto_connection_success" ?
          <>
            <p>{this.trans("ponto_was_successfully_connected_1")}</p>
            <p>{this.trans("ponto_was_successfully_connected_2")}</p>
          </> :
          <>
            <p>{this.trans("ponto_failed_connection_1")}</p>
            <p>{this.trans("ponto_failed_connection_2", {message: this.state?.pontoConnectionDialogMessageFromParams})}</p>
          </>
          }
          openLeavePrompt={this.state.pontoConnectionDialogFromParams}
          positiveButtonLabel={this.trans("button-close")}
          onSave={() => {
            this.setState({pontoConnectionDialogFromParams: false});
            this.props.dispatch({
              type: Constants.PONTO_CONNECTION_MESSAGE_SHOWN,
              payload: false
            });
          }}
          onDiscard={() => {
            this.setState({pontoConnectionDialogFromParams: false});
            this.props.dispatch({
              type: Constants.PONTO_CONNECTION_MESSAGE_SHOWN,
              payload: false
            });
          }}
          onlyPositiveButton={true}
        />

        <PaymentCreateDialog 
          {...this.props}
          isOpened={this.state.isPaymentCreatePopupOpen}
          title={this.trans("title-new-payment")}
          onCancel={() => {
            this.setState({
              isPaymentCreatePopupOpen: false
            });
          }}
        />

        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.isBankTransactionsDilaogOpen}
          title={this.trans("title-attention") + "!"}
          content={(
            <div>
              <div>
                {this.trans("preprocess/selectbanktransactionfile-info")}
              </div>
              <div style={{display: "flex", justifyContent: "flex-end"}}>
                <Button
                  color="primary"
                  style={{
                    marginRight: "7px",
                    position: "relative",
                    zIndex: 2
                  }}
                  onClick={() => {this.setState({isBankTransactionsDilaogOpen: false})}}
                >
                  {this.trans("dialog-button/cancel")}
                </Button>
                <input
                  type="file"
                  accept=".STA, .940"
                  style={{
                    display: "none"
                  }}
                  multiple={false}
                  onChange={this.upload}
                  id="button-file"
                  ref={this.fileInput}
                />
                <label htmlFor="button-file">
                  <Button
                    variant="contained"
                    color="primary"
                    className={"new-attachment-button"}
                    onClick={() => this.fileInput.current.click()}
                  >
                    {this.trans("dialog-button/selectmt940file")}
                  </Button>
                </label>
              </div>
            </div>
          )}
          onClose={this.closeBankTransactionsDialog}
          withoutDefaultDilaogButtons={true}
        />

        <PromptDialog
          {...this.props}
          title={!!fileDetails && fileDetails.state === 3 ? this.trans("processing-file") : (!!fileDetails && fileDetails.title) || this.trans("uploading")}
          content={this.renderDialogContent()}
          openLeavePrompt={this.state.isDialogOpen}
          onSave={this.closeDialog}
          onlyPositiveButton={true}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={false}
          actions={
            [
              <Button
                variant="contained"
                color="primary"
                disabled={!!fileDetails && fileDetails.disableButton}
                onClick={this.continue}
              >
                {this.trans("button-close")}
              </Button>
            ]
          }
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    payments: state.payments,
    component: state.bankTransactions,
    globalTypes: state.globalTypes,
    bankAccountUpdate: state.bankAccountUpdate
  };
};

export default connect(mapStateToProps)(
  Payments
);
